import { Box } from '@mui/material';
import About from './About';
import ExternalLinksMenu from './ExternalLinksMenu';
import GlobalSettings from './GlobalSettings';

export default function ApplicationQuickMenu() {
    return (
        <Box display="flex" gap={0.5} flexDirection="row" alignItems="center">
            <About />
            <GlobalSettings />
            <ExternalLinksMenu />
        </Box>
    );
}
